export default class ApplicationUserApiKeyDto {
  constructor(options = {}) {
    this.id = options.id || 0;
    this.userId = options.applicationUserId|| ''; 
    this.apiKey = options.apiKey || '';;
  }
}
